import { render, staticRenderFns } from "./latelyChat.vue?vue&type=template&id=b5b9840a&scoped=true&"
import script from "./latelyChat.vue?vue&type=script&lang=ts&"
export * from "./latelyChat.vue?vue&type=script&lang=ts&"
import style0 from "./latelyChat.vue?vue&type=style&index=0&id=b5b9840a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b9840a",
  null
  
)

export default component.exports